import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberScopus } from "./routeType";

const { key, getPath } = getApi("members.scopus.put");

type IExtractedRouteType = IMemberScopus["scopusDataSingleUpdate"];

export type IPutMemberScopus = IPickMutation<IExtractedRouteType>;

const putMemberScopus: Fetcher<
  IPutMemberScopus["response"],
  IPutMemberScopus["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.put(getPath({ memberId }), data);
};

export const usePutMemberScopus = createQuery({
  queryKey: [key],
  fetcher: putMemberScopus,
});
